import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authApi from '../../api/auth';
import { LOGIN_COVER } from '../../assets/images';
import  NAV_LOGO  from '../../assets/logos/World_O_Tutor.png';
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { login } from '../../reducers/authSlice';
import EmailScreen from './EmailScreen';
import LicenseTerms from './LicenseTerms';

export default function Login() {
  const [step, setStep] = useState<number>(0);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { tutor } = useAppSelector((state) => state.authSlice);
  const [error /* , setError */] = useState('');

  useEffect(() => {
    if (tutor?._id) {
      if (tutor.termsOfUse === 'accepted') {
        navigate('/dashboard');
      } else {
        setStep(1);
      }
    } else {
      authApi
        .authStatus()
        .then((data) => {
          if (data.status === 'OK') {
            dispatch(login(data.data));
          }
        })
        .catch((/* err */) => {
          /* console.log(err) */
        });
    }
  }, [tutor]);

  return (
    <div className="w-full flex flex-col h-screen">
      <div className="hidden md:flex border border-neutralBlue1">
        <Link to="https://student.worldotutor.com" className=" h-14 flex items-center w-11/12 mx-auto">
          <img src={NAV_LOGO} alt="WorldOTutor Logo" className='max-w-44' />
        </Link>
      </div>
      <div className="w-full h-screen flex lg:flex-row md:justify-center md:bg-neutralGray4">
        <div className="lg:bg-primary lg:w-1/2 lg:h-full lg:flex hidden">
          <div className="w-full h-full flex flex-col items-center justify-center">
            <div className="h-80">
              <img src={LOGIN_COVER} alt="worldotutor_login_cover" className="w-full h-full object-contain" />
            </div>
            <div className="w-1/2">
              <h1 className="text-5xl leading-snug font-bold text-white text-center">Welcome to World O Tutor</h1>
            </div>
          </div>
        </div>
        <div className="flex lg:w-1/2 md:w-4/5 w-full h-full items-center justify-center bg-white md:bg-neutralGray4">
          <div className="flex flex-col py-6 px-4 md:px-6 lg:px-12 w-11/12 lg:w-4/5  min-h-[90%] md:bg-white rounded-xl md:border border-neutralBlue1 md:shadow-md">
            {step === 0 ? (
              <>
                {error && <p className="text-base text-red-500 font-semibold my-5">{error}</p>}
                <EmailScreen setStep={setStep} />
              </>
            ) : step === 1 ? (
              <LicenseTerms setStep={setStep} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
